import FetchStatus from "@/constants/fetch-status/FetchStatus";
import {
	GET_FILTERED_RESULT_SETS,
	GET_FILTERED_RESULT_SETS_SUCCESS,
	GET_FILTERED_RESULT_SETS_ERROR,
	GET_WORST_RESULT_SETS,
	GET_WORST_RESULT_SETS_SUCCESS,
	GET_WORST_RESULT_SETS_ERROR,
} from "@/stores/actions/ResultSets";

import WindDiagnosticResultSetService from "@/services/wind/diagnostic/WindDiagnosticResultSetService";
import ResultSetFactory from "@/factories/wind/diagnostic/ResultSetFactory";

const state = ResultSetFactory.ResultSetsState();

const actions = {
	[GET_FILTERED_RESULT_SETS]: async({ commit }, parameters) =>
	{
		commit(GET_FILTERED_RESULT_SETS);
		try
		{
			const filteredResultSets = await WindDiagnosticResultSetService.GetResultSets(parameters);

			commit(GET_FILTERED_RESULT_SETS_SUCCESS, filteredResultSets);
		}
		catch (error)
		{
			commit(GET_FILTERED_RESULT_SETS_ERROR, error);
		}
	},

	[GET_WORST_RESULT_SETS]: async({ commit }, parameters) =>
	{
		commit(GET_WORST_RESULT_SETS);

		try
		{
			const worstResultSets = await WindDiagnosticResultSetService.GetWorstResultSets(parameters);

			commit(GET_WORST_RESULT_SETS_SUCCESS, worstResultSets);
		}
		catch (error)
		{
			commit(GET_WORST_RESULT_SETS_ERROR, error);
		}
	},
};

const mutations = {
	[GET_FILTERED_RESULT_SETS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
		state.data = [];
		state.stage2ResultSets = [];
		state.stage3ResultSets = [];
		state.planetaryResultSets = [];
		state.loosenessResultSets = [];
		state.angularMisalignmentHssResultSets = [];
		state.parallelMisalignmentHssResultSets = [];
		state.mainShaftUnbalanceResultSets = [];
		state.generatorShaftUnbalanceResultSets = [];
		state.angularMisalignmentResultSets = [];
		state.parallelMisalignmentResultSets = [];
		state.generatorElectricFail = [];
		state.bearingsResultSets = [];
		state.generatorUpWindBearingResultSets = [];
		state.generatorDownWindBearingResultSets = [];
		state.gearboxHSSUpWindBearingResultSets = [];
		state.gearboxHSSDownWindUpBearingResultSets = [];
		state.gearboxHSSDownWindDownBearingResultSets = [];
		state.gearboxIMSUpWindBearingResultSets = [];
		state.gearboxIMSDownWindBearingResultSets = [];
		state.gearboxLSSUpWindBearingResultSets = [];
		state.gearboxLSSDownWindUpBearingResultSets = [];
		state.gearboxLSSDownWindDownBearingResultSets = [];
		state.gearboxPlanetaryBearingResultSets = [];
		state.gearboxPlanetaryDownWindBearingResultSets = [];
		state.gearboxPlanetaryUpWindBearingResultSets = [];
		state.mainShaftBearingResultSets = [];
		state.mainShaftUpWindBearingResultSets = [];
		state.mainShaftDownWindBearingResultSets = [];
	},
	[GET_FILTERED_RESULT_SETS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_FILTERED_RESULT_SETS_SUCCESS]: (state, resp) =>
	{
		state.data = resp.mainResultSetsList;
		state.stage2ResultSets = resp.stage2ResultSets;
		state.stage3ResultSets = resp.stage3ResultSets;
		state.planetaryResultSets = resp.planetaryResultSets;
		state.parallelMisalignmentHssResultSets = resp.parallelMisalignmentHssResultSets;
		state.angularMisalignmentHssResultSets = resp.angularMisalignmentHssResultSets;
		state.bearingsResultSets = resp.bearingsResultSets;
		state.loosenessResultSets = resp.loosenessResultSets;
		state.imbalanceMainShaftResultSets = resp.imbalanceMainShaftResultSets;
		state.angularMisalignmentResultSets = resp.angularMisalignmentResultSets;
		state.parallelMisalignmentResultSets = resp.parallelMisalignmentResultSets;
		state.parallelMisalignmentGeneratorShaftResultSets = resp.parallelMisalignmentGeneratorShaftResultSets;
		state.generatorShaftUnbalanceResultSets = resp.generatorShaftUnbalanceResultSets;
		state.generatorElectricFail = resp.generatorElectricFail;
		state.status = FetchStatus.Loaded;
	},
	[GET_WORST_RESULT_SETS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
		state.data = [];
		state.stage2ResultSets = [];
		state.stage3ResultSets = [];
		state.planetaryResultSets = [];
		state.loosenessResultSets = [];
		state.angularMisalignmentHssResultSets = [];
		state.parallelMisalignmentHssResultSets = [];
		state.mainShaftUnbalanceResultSets = [];
		state.generatorShaftUnbalanceResultSets = [];
		state.angularMisalignmentResultSets = [];
		state.parallelMisalignmentResultSets = [];
		state.generatorElectricFail = [];
		state.bearingsResultSets = [];
		state.generatorUpWindBearingResultSets = [];
		state.generatorDownWindBearingResultSets = [];
		state.gearboxHSSUpWindBearingResultSets = [];
		state.gearboxHSSDownWindUpBearingResultSets = [];
		state.gearboxHSSDownWindDownBearingResultSets = [];
		state.gearboxIMSUpWindBearingResultSets = [];
		state.gearboxIMSDownWindBearingResultSets = [];
		state.gearboxLSSUpWindBearingResultSets = [];
		state.gearboxLSSDownWindUpBearingResultSets = [];
		state.gearboxLSSDownWindDownBearingResultSets = [];
		state.gearboxPlanetaryBearingResultSets = [];
		state.gearboxPlanetaryDownWindBearingResultSets = [];
		state.gearboxPlanetaryUpWindBearingResultSets = [];
		state.mainShaftBearingResultSets = [];
		state.mainShaftUpWindBearingResultSets = [];
		state.mainShaftDownWindBearingResultSets = [];
	},
	[GET_WORST_RESULT_SETS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_WORST_RESULT_SETS_SUCCESS]: (state, resp) =>
	{
		state.data = resp.mainResultSetsList;
		state.stage2ResultSets = resp.stage2ResultSets;
		state.stage3ResultSets = resp.stage3ResultSets;
		state.planetaryResultSets = resp.planetaryResultSets;
		state.bearingsResultSets = resp.bearingsResultSets;
		state.loosenessResultSets = resp.loosenessResultSets;
		state.imbalanceMainShaftResultSets = resp.imbalanceMainShaftResultSets;
		state.angularMisalignmentResultSets = resp.angularMisalignmentResultSets;
		state.parallelMisalignmentResultSets = resp.parallelMisalignmentResultSets;
		state.parallelMisalignmentGeneratorShaftResultSets = resp.parallelMisalignmentGeneratorShaftResultSets;
		state.generatorShaftUnbalanceResultSets = resp.generatorShaftUnbalanceResultSets;
		state.generatorElectricFail = resp.generatorElectricFail;
		state.angularMisalignmentHssResultSets = resp.angularMisalignmentHssResultSets;
		state.parallelMisalignmentHssResultSets = resp.parallelMisalignmentHssResultSets;
		state.generatorUpWindBearingResultSets = resp.generatorUpWindBearingResultSets;
		state.generatorDownWindBearingResultSets = resp.generatorDownWindBearingResultSets;
		state.gearboxHSSUpWindBearingResultSets = resp.gearboxHSSUpWindBearingResultSets;
		state.gearboxHSSDownWindUpBearingResultSets = resp.gearboxHSSDownWindUpBearingResultSets;
		state.gearboxHSSDownWindDownBearingResultSets = resp.gearboxHSSDownWindDownBearingResultSets;
		state.gearboxIMSUpWindBearingResultSets = resp.gearboxIMSUpWindBearingResultSets;
		state.gearboxIMSDownWindBearingResultSets = resp.gearboxIMSDownWindBearingResultSets;
		state.gearboxLSSUpWindBearingResultSets = resp.gearboxLSSUpWindBearingResultSets;
		state.gearboxLSSDownWindUpBearingResultSets = resp.gearboxLSSDownWindUpBearingResultSets;
		state.gearboxLSSDownWindDownBearingResultSets = resp.gearboxLSSDownWindDownBearingResultSets;
		state.gearboxPlanetaryBearingResultSets = resp.gearboxPlanetaryBearingResultSets;
		state.gearboxPlanetaryDownWindBearingResultSets = resp.gearboxPlanetaryDownWindBearingResultSets;
		state.gearboxPlanetaryUpWindBearingResultSets = resp.gearboxPlanetaryUpWindBearingResultSets;
		state.mainShaftBearingResultSets = resp.mainShaftBearingResultSets;
		state.mainShaftUpWindBearingResultSets = resp.mainShaftUpWindBearingResultSets;
		state.mainShaftDownWindBearingResultSets = resp.mainShaftDownWindBearingResultSets;
		state.status = FetchStatus.Loaded;
	},
};

export default {
	state,
	actions,
	mutations,
};
